<template>
  <div>yeljkj</div>
</template>

<script>
import { getShangPin } from "@/api/shangpin";
import { getShangPinFenLei } from "@/api/shanpin_fenlei";

export default {
  name: "Product",
  components: {},
  data() {
    return {
      ukey: "",
      product: {},
      category: {},
      relatedproduct: [],
      count: 1,
    };
  },
  mounted() {
    this.ukey = this.$route.query.ukey;
    this.get_product_http();
  },
  methods: {
    get_product_http() {
      getShangPin({ ukey: this.ukey }).then((data) => {
        if (data.status === "SUCCESSED" && data.data.length > 0) {
          this.product = data.data[0];
          this.get_category_http();
        }
      });
    },
    get_category_http() {
      const categorys = this.product.category.split("-");
      getShangPinFenLei({ id: categorys[categorys.length - 2] }).then(
        (data) => {
          if (data.status === "SUCCESSED") {
            this.category = data.data;
            getShangPin({ category: this.category.id }).then((data) => {
              if (data.status === "SUCCESSED") {
                this.relatedproduct = data.data;
              }
            });
          }
        },
      );
    },
  },
};
</script>
